
export default {
  Close: '关 闭',
  Confirm: '确定',
  header: {
    Home: '首页',
    MyOrder: '我的订单',
    Login: '登录',
    changeYourPassword: '修改密码',
    logout: '退出'
  },
  Announcement: '公告',
  WeChatTitle: '秦始皇帝陵博物院微信公众号',
  PleaseUseWeChat: '请使用微信扫描上方公众号二维码',
  CountDown: '倒计时',
  CountDownComplete: '关闭',
  buyTicket: {
    selectAVisitDate: '选择参观日期',
    selectAVisitTime: '请选择检票进场时段',
    selectTicketType: '选择票类',
    maxNum: `一笔订单最多购买&valItem张门票`,
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    Sunday: '星期日',
    notBooking: '不可预约',
    ticketBalance: '余量',
    productName: '产品名称',
    ticketType: '票种',
    ticketingInstructions: '购票须知',
    PleaseRead: '请仔细阅读须知',
    IRead: '我已详细阅读，继续预定',
    UnitPrice: '单价',
    Quantity: '数量',
    noDataAvailable: '暂无数据',
    telephoneConsultation: '电话咨询',
    onlineConsultation: '在线咨询',
    weChatOfficialAccount: '微信公众号',
    Reminder: '提示',
    totalPrice: '总价',
    placeOrder: '提交订单',
    ticketingInstructions: '购票须知',
    Total: '合计',
    totalNum: '共&valItem张',
    TotalPrice: '总价',
    LatestAnnouncement: '最新公告',
    viewMore: '查看更多'
  },
  // 购票进程
  TicketingProcessObj: {
    TicketingProcess: '购票进程',
    TimeOut: '选择检票进场时段',
    selectTicketType: '选择票类',
    FillOrder: '填写订单信息',
    OrderPayment: '订单支付',
    Completed: '完成'
  },
  // 账号密码登录注册修改
  LoginObj: {
    LoginAndPassword: '账号密码登录',
    LoginCode: '验证码登录',
    PleaseNumber: '请输入您的手机号',
    PleasePassword: '请输入密码',
    Change: '换一换',
    PleaseCode: '请输入验证码',
    PleaseAgain: '请再次输入密码',
    LogIn: '立即登录',
    SignUpNow: '立即注册',
    ForgotPassword: '忘记密码',
    AgreeDisclaimer: '同意会员条款和免责声明',
    GetVerificationCode: '获取验证码',
    Reacquire: '重新获取',
    NoAccount: '没有账号',
    ChangePassword: '修改密码',
    Logout: '退出',
    ExistingAccount: '已有账号',
    ImmediatelyFind: '立即找回'
  },
  // 下单页
  FillOrder: {
    FillOrder: '填写订单信息',
    FillOrderTitle: '秦始皇帝陵博物院购票实行实名制，所有观众需录入身份信息方可预定',
    VisitDate: '参观日期',
    Name: '姓名',
    DocumentType: '证件类型',
    IDCard: '身份证',
    Passport: '护照',
    Others: '其他',
    IDNumber: '证件号',
    SpecialIDType: '特殊证件类型',
    SpecialIDNumber: '特殊证件号',
    DeleteThisContact: '删除此联系人',
    PleaseYourName: '请输入姓名',
    PleaseIDNumber: '请输入证件号',
    PleaseSpecialIDNumber: '请输入特殊证件号',
    PleaseenterContact: '请输入联系人手机号码',
    Delete: '删除',
    information: '联系人信息',
    informationSub: '（请准确填写，以免无法接收订单信息）',
    ContactPhoneNumber: '联系手机号',
    TotalAmount: '总金额',
    BuyNow: '立即购买',
    ConfirmReminder: '确认提示',
    DoubleConfirm: '再次确认',
    Confirmed: '确认无误',
    BeforeBy: '立即购买前，请确认身份信息是否输入正确，以免影响您的参观体验。',
    OutByOrder: '温馨提示',
    Mausoleum: '秦始皇帝陵博物院欢迎您！温馨提示：每日系统维护，维护时间为：23:30至次日02：30，在此期间暂停售票服务。',
    Reminder: '提示信息',
    PleaseCorrectInformation: '请填写正确的信息',
    AgeDiscountRange: '您的年龄不符合优惠范围内',
    InvalidIDNumber: '身份证号码无效',
    productName: '产品名称',
    ticketType: '票种',
    Quantity: '数量',
    UnitPrice: '单价'
  },
  back: '返回',
  // 支付
  payOrder: {
    OrderQuantity: '订单数量',
    NumberProducts: '商品数量',
    OrderInformation: '订单信息',
    VisitTime: '参观时间',
    TicketName: '票名称',
    ticketType: '票种',
    UnitPrice: '单价',
    Quantity: '数量',
    PaymentOrderSeconds: '支付订单剩余时间:&item1分&item2秒',
    PleaseComplete: '请及时完成，否则订单将自动取消',
    Alipay: '支付宝',
    WeChat: '微信',
    PleaseQRcodepay: '请扫码支付',
    Orderpaymenttimeout: '订单支付超时，请重新下单！',
    goFillOrderL: '去下单',
    Backtohome: '返回首页',
    Checkorder: '查看订单',
    Refund: '退款',
    TicketReplacement: '补票',
    ChangeTicket: '改签',
    RefundProgress: '退款中'
  },
  Cancel: '取消',
  Backtohome: '返回首页',
  Checkorder: '查看订单',
  LatestAnnouncement: '最新公告',
  PreviousPage: '上一页',
  NextPage: '下一页',
  ReleaseTime: '发布时间',
  MyOrder: {
    MyOrder: '我的订单',
    OrderCenter: '订单中心',
    All: '全部',
    Completed: '已完成',
    ToBePaid: '待支付',
    OrderNumber: '订单编号',
    VisitorIDNumber: '出行人证件号',
    Inquire: '查询',
    Reset: '重置',
    OrderPlacementTime: '下单时间',
    Contactphonenumber: '联系人手机号',
    OrderStatus: '订单状态',
    Startdate: '开始日期',
    EndDate: '结束日期',
    VisitTime: '参观时间',
    Visitdate: '出游日期',
    VisitTimePeriod: '参观时段',
    Actualpaymentpaymentmethod: '实付款/支付方式',
    Operating: '操作',
    OrderDetails: '订单详情',
    Paymentquery: '支付查询',
    Expandall: '展开所有',
    CreationDate: '创建时间',
    Fullorderamount: '订单全额',
    Fullpayment: '实付全额',
    Fullrefund: '退款全额',
    Handlingfee: '手续费',
    Ticketnumber: '票号',
    TicketcheckingQRcode: '验票二维码',
    Effectivedate: '有效日期',
    Effectivetime: '有效时间',
    Numberofpeople: '人数',
    Numberoftimes: '次数',
    Ticketcollectiondate: '取票日期',
    Numberofprints: '打印次数',
    Numberofticketschecked: '已验次数',
    Ticketstatus: '票状态',
    Checkingrecords: '检票记录',
    Uncollectedticket: '未取票',
    Void: '作废',
    Checkinrecords: '检票记录',
    Close: '关闭',
    Checkininformation: '检票信息',
    Ticketidentificationnumber: '检票识别号',
    Checkindate: '检票日期',
    Checkintime: '检票时间',
    Checkpointname: '检票点名称',
    Nodataavailable: '查无数据',
    Price: '价格',
    Handlingfee: '手续费',
    selectText: '已选&item1张，合计',
    selectText2: '扣除手续费',
    selectVisitTime: '请选择参观时间'
  },
  orderStatus: {
    Pendingreview: '待审核',
    Closed: '已关闭',
    Issued: '已出票',
    Tobepaid: '待支付',
    Refunded: '已退款',
    Completed: '已完成'
  },
  status: '状态',
  Ticketcollectionstatus: '取票状态',
  Pickedup: '已取票',
  NotPickup: '未取票',
  Ticketcheckintype: '检票类型',
  Normalticketcheckin: '正常检票',
  Freeadmissionticketcheckin: '免票检票',
  Mandatoryticketcheckin: '强制检票',
  Ticketcheckmedia: '检票介质',
  Ticketidentificationnumber: '检票识别号',
  Checkindate: '检票日期',
  Checkintime: '检票时间',
  Checkpointname: '检票点名称',
  el: {
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共{total}条',
      pageClassifier: '页'
    }
  }
}
